import { useQuery } from '@tanstack/react-query';
import { useApiClient } from '@/context/ApiClientContext/useApiClient.ts';
import useAutomationId from '@/hooks/useAutomationId.ts';
import { AutomationVersionTestCaseRun } from '@/types/automations.ts';
import { AUTOMATION_VERSION_TEST_CASE_RUNS_KEY } from '@/utils/queryKeys.ts';
import { get_automation_version_test_case_runs_url } from '@/utils/urls.ts';

const useRetrieveAutomationVersionTestCaseRuns = (versionId?: string, caseId?: string, enabled = true) => {
  const apiClient = useApiClient();
  const automationId = useAutomationId();

  return useQuery<{ runs: AutomationVersionTestCaseRun[] }, Error>({
    queryKey: AUTOMATION_VERSION_TEST_CASE_RUNS_KEY(automationId, versionId, caseId),
    queryFn: async () => (await apiClient.get(get_automation_version_test_case_runs_url(versionId, caseId))).data,
    enabled: enabled && !!automationId && !!versionId && !!caseId,
  });
};

export default useRetrieveAutomationVersionTestCaseRuns;
